import { render, staticRenderFns } from "./IndexAccess.vue?vue&type=template&id=9fe72590"
import script from "./IndexAccess.vue?vue&type=script&lang=js"
export * from "./IndexAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports